module.exports = __webpack_public_path__ + "img/close.5aa7e25b.svg";